import { RefreshEIMP } from './RefreshEIMP';
import { RiskRecordActionPathAssociation } from './RiskRecordActionPathAssociation';
import { RiskRecordActionPathDisassociation } from './RiskRecordActionPathDisassociation';
import { RiskRecordNoteUpdate } from './RiskRecordNoteUpdate';
import { RiskRecordTagAssignment } from './RiskRecordTagAssignment';
import { RiskRecordTagUnassignment } from './RiskRecordTagUnassignment';
import { ScheduleExport } from './ScheduleExport';

/**
 * mutations
 *
 * @type {{RefreshEIMP: ((function({}=): Promise<*>)|*), RiskRecordActionPathAssociation: ((function({}=): Promise<*>)|*), RiskRecordActionPathDisassociation: ((function({}=): Promise<*>)|*), RiskRecordNoteUpdate: ((function({}=): Promise<*>)|*), RiskRecordTagAssignment: ((function({}=): Promise<*>)|*), RiskRecordTagUnassignment: ((function({}=): Promise<*>)|*), ScheduleExport: ((function({}=): Promise<*>)|*)}}
 */
export const mutations = {
  RefreshEIMP,
  RiskRecordActionPathAssociation,
  RiskRecordActionPathDisassociation,
  RiskRecordNoteUpdate,
  RiskRecordTagAssignment,
  RiskRecordTagUnassignment,
  ScheduleExport,
};
